<template>
  <div class="hp-page">
    <HotPursuitBackGround />

    <!-- Pitch + crédibilité -->
    <section class="hp-intro">
      <b-container>
        <p class="hp-pitch" v-reveal>{{ t.game_pitch }}</p>
        <ul class="hp-stats" v-reveal>
          <li><strong>★ 4,8</strong><span>30 avis</span></li>
          <li><strong>PEGI 3</strong><span>Tous publics</span></li>
          <li><strong>Gratuit</strong><span>Android</span></li>
          <li><strong>Arcade</strong><span>Course</span></li>
        </ul>
      </b-container>
    </section>

    <!-- Feature 1 : gameplay -->
    <section class="section">
      <b-container>
        <div class="feature" v-reveal>
          <div class="feature-visual">
            <div class="feature-glow"></div>
            <img
              :src="require('@/assets/in_game_phone.png')"
              alt="Gameplay de Hot Pursuit"
              class="feature-phone"
              loading="lazy" />
          </div>
          <div class="feature-text">
            <span class="eyebrow">Gameplay</span>
            <h2 class="feature-title">{{ t.game_description_title }}</h2>
            <p class="feature-desc">{{ t.game_description }}</p>
          </div>
        </div>
      </b-container>
    </section>

    <!-- Feature 2 : personnalisation -->
    <section class="section feature-alt">
      <b-container>
        <div class="feature feature-reverse" v-reveal>
          <div class="feature-text">
            <span class="eyebrow">Garage</span>
            <h2 class="feature-title">{{ t.game_customisation_title }}</h2>
            <p class="feature-desc">{{ t.game_customisation }}</p>
          </div>
          <div class="feature-visual">
            <VehiculesSlider />
          </div>
        </div>
      </b-container>
    </section>

    <!-- CTA téléchargement -->
    <section class="download-cta">
      <b-container>
        <div class="download-inner" v-reveal>
          <h2 class="download-title">{{ t.download_title }}</h2>
          <p class="download-sub">{{ t.download_sub }}</p>
          <a
            class="gplay-badge"
            href="https://play.google.com/store/apps/details?id=com.ClubBabyPro.HotPursuit&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            target="_blank" rel="noopener noreferrer">
            <img
              alt="Disponible sur Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" />
          </a>
        </div>
      </b-container>
    </section>
  </div>
</template>

<script>
import en from '@/en'
import fr from '@/fr'
import HotPursuitBackGround from '@/components/BackGroundHotPursuit.vue'
import VehiculesSlider from '@/components/VehiculesSlider.vue'

export default {
  name: 'HotPursuit',
  components: {
    HotPursuitBackGround,
    VehiculesSlider,
  },
  data () {
    return {
      languages: {
        en,
        fr
      }
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    },
    t () {
      return this.languages[this.language]
    }
  }
}
</script>

<style scoped lang="scss">
  /* ---------- Pitch + stats ---------- */
  .hp-intro {
    padding: clamp(2.5rem, 6vw, 4.5rem) 0 0;
    text-align: center;
  }
  .hp-pitch {
    max-width: 60ch;
    margin: 0 auto clamp(2rem, 4vw, 3rem);
    font-size: clamp(1.1rem, 2vw, 1.4rem);
    color: var(--text);
    font-family: 'agency', sans-serif;
  }
  .hp-stats {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: clamp(1rem, 3vw, 2.5rem);
  }
  .hp-stats li {
    display: flex;
    flex-direction: column;
    min-width: 90px;
  }
  .hp-stats strong {
    font-family: 'agency', sans-serif;
    font-size: clamp(1.4rem, 3vw, 2rem);
    color: var(--gold-600);
    line-height: 1.1;
  }
  .hp-stats span {
    font-size: 0.85rem;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .feature {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: clamp(2rem, 5vw, 4.5rem);
  }

  .feature-alt {
    background: linear-gradient(180deg, transparent, rgba(255, 255, 255, 0.02), transparent);
  }

  .feature-text {
    text-align: left;
  }
  .feature-title {
    font-family: 'fightt', sans-serif;
    font-size: clamp(2.4rem, 6vw, 4.2rem);
    margin-bottom: 1rem;
  }
  .feature-desc {
    color: var(--text-muted);
    font-size: clamp(1rem, 1.5vw, 1.15rem);
    max-width: 48ch;
  }

  .feature-visual {
    position: relative;
    display: flex;
    justify-content: center;
  }
  .feature-glow {
    position: absolute;
    inset: 12% 6%;
    background: radial-gradient(ellipse at center, rgba(47, 107, 255, 0.20), transparent 68%);
    filter: blur(45px);
    z-index: 0;
  }
  .feature-phone {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 620px;
    height: auto;
    filter: drop-shadow(0 24px 42px rgba(20, 28, 45, 0.30));
  }

  /* ---------- CTA téléchargement ---------- */
  .download-cta {
    padding: clamp(3rem, 7vw, 6rem) 0;
    text-align: center;
  }
  .download-inner {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(47, 107, 255, 0.08));
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: clamp(2rem, 5vw, 3.5rem);
    box-shadow: var(--shadow-card);
  }
  .download-title {
    font-family: 'fightt', sans-serif;
    font-size: clamp(2.2rem, 5.5vw, 3.6rem);
    margin-bottom: 0.5rem;
  }
  .download-sub {
    color: var(--text-muted);
    margin-bottom: 1.75rem;
  }
  .gplay-badge img {
    height: 68px;
    width: auto;
    transition: transform 0.2s ease, filter 0.2s ease;
  }
  .gplay-badge:hover img {
    transform: translateY(-3px);
    filter: drop-shadow(0 8px 20px rgba(34, 197, 94, 0.4));
  }

  /* ---------- Responsive ---------- */
  @media (max-width: 850px) {
    .feature,
    .feature-reverse {
      grid-template-columns: 1fr;
      text-align: center;
    }
    .feature-text {
      text-align: center;
    }
    .feature-desc {
      margin-left: auto;
      margin-right: auto;
    }
    .feature-visual {
      order: -1;
    }
    .feature-reverse .feature-visual {
      order: 0;
    }
    .feature-phone {
      max-width: 460px;
    }
  }
</style>
